import * as Sentry from '@sentry/browser'

declare let RELEASE_NAME: string
declare let ENVIRONMENT: 'prod' | 'ci' | 'dev'

export const configureSentry = () => {
    ENVIRONMENT === 'prod'
        ? Sentry.init({
              dsn: 'https://3e5395691c0046ee82579883f0cda71c@o370555.ingest.sentry.io/5216309',
              release: RELEASE_NAME,
              ignoreErrors: [],
              normalizeDepth: 15,
          })
        : null
}
